import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import { db } from "@/main.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    fields: null,
    contactInfo: {
      name: "Nicole Loeve",
      email: "info@sanavitasportmassage.nl",
      tel: "+316 45802776",
      address: {
        street: "Makreelstraat",
        houseNumber: "32",
        postalCode: "5706 BH",
        city: "Helmond"
      }
    },
    openingTimes: [
      {
        title: "Maandag",
        slots: [
          {
            from: "13:00",
            to: "17:00"
          },
          {
            from: "18:30",
            to: "21:30"
          }
        ]
      },
      {
        title: "Dinsdag",
        slots: [
          {
            from: "13:30",
            to: "17:00"
          }
        ]
      },
      {
        title: "Woensdag",
        slots: [
          {
            from: "09:30",
            to: "17:00"
          },
          {
            from: "18:30",
            to: "21:30"
          }
        ]
      },
      {
        title: "Donderdag",
        slots: [
          {
            from: "14:00",
            to: "17:00"
          },
          {
            from: "18:30",
            to: "21:30"
          }
        ]
      },
      {
        title: "Vrijdag",
        slots: [
          {
            from: "14:00",
            to: "17:00"
          },
          {
            from: "18:30",
            to: "21:30"
          }
        ]
      }
    ],
    diensten: [
      {
        name: "Sportmassage",
        link: "sportmassage",
        tarieven: [
          {
            min: 60,
            fieldId: "sportmassage_tarief_60"
          },
          {
            min: 45,
            fieldId: "sportmassage_tarief_45"
          },
          {
            min: 30,
            fieldId: "sportmassage_tarief_30"
          }
        ]
      },
      {
        name: "Ontspanningsmassage",
        link: "ontspanningsmassage",
        tarieven: [
          {
            min: 60,
            fieldId: "ontspanningsmassage_tarief_60"
          },

          {
            min: 45,
            fieldId: "ontspanningsmassage_tarief_45"
          },
          {
            min: 30,
            fieldId: "ontspanningsmassage_tarief_30"
          }
        ]
      },
      {
        name: "Medical taping",
        link: "medicaltaping",
        tarieven: [
          {
            min: "Variabele",
            fieldId: "medicaltaping_tarief",
            prefix: "(vanaf)",
            description:
              "* Afhankelijk van de hoeveelheid gebruikte  tape en tijdsduur"
          }
        ]
      }
    ]
  },
  getters: {
    user(state) {
      return state.user;
    },
    contactInfo(state) {
      return state.contactInfo;
    },
    openingTimes(state) {
      return state.openingTimes;
    },
    fields(state) {
      return state.fields;
    },
    diensten(state) {
      return state.diensten;
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setFields(state, fields) {
      state.fields = fields;
    }
  },
  actions: {
    login({ commit }, payload) {
      return new Promise((resolve, reject) => {
        if (!payload.email || !payload.password) {
          reject("Niet alle gegevens ingevuld");
        }

        firebase
          .auth()
          .signInWithEmailAndPassword(payload.email, payload.password)
          .then(res => {
            commit("setUser", res.user);
            resolve("Ingelogd");
          })
          .catch(function(error) {
            reject("Fout bij inloggen");
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signOut()
          .then(function() {
            commit("setUser", null);
            resolve("Uitgelogd");
          })
          .catch(function(error) {
            reject("Fout bij uitloggen");
          });
      });
    },
    getFields({ commit }) {
      db.collection("fields")
        .get()
        .then(function(querySnapshot) {
          let fields = [];
          querySnapshot.forEach(function(doc) {
            fields.push({ id: doc.id, value: doc.data().value });
          });
          console.log(fields);
          commit("setFields", fields);
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    async setField({}, field) {
      try {
        await db
          .collection("fields")
          .doc(field.id)
          .set({ value: field.value });

        return true;
      } catch (err) {
        throw err;
      }
    }
  }
});
